module.exports = __webpack_public_path__ + "static/media/category15.40eee107.png";